<template>
  <div>
    <t-form labelWidth="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="文本">
          <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.title.textStyle.color" enableAlpha/>
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :min="4" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.visualMap.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.visualMap.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.visualMap.top" :direction="'y'"/>
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.visualMap.textStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="路线">
        <t-form-item label="显示">
          <t-switch v-model="attribute.line.show" :label="['显示', '不显示']" size="small"/>
        </t-form-item>
        <t-form-item label="路线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.line.lineStyle.color"/>
        </t-form-item>
        <t-form-item label="透明度">
          <t-input-number size="small" v-model="attribute.line.lineStyle.opacity" :min="0" :max="1" :decimal-places="1" :step="0.1"/>
        </t-form-item>
        <t-form-item label="线宽">
          <t-input-number size="small" v-model="attribute.line.lineStyle.width" :min="0" :max="20" :decimal-places="1" :step="0.1"/>
        </t-form-item>
        <t-form-item label="弯曲度">
          <t-input-number size="small" v-model="attribute.line.lineStyle.curveness" :min="0" :max="10" :decimal-places="1" :step="0.1"/>
        </t-form-item>
        <t-form-item label="光点显示">
          <t-switch v-model="attribute.line.effect.show" :label="['显示', '不显示']" size="small"/>
        </t-form-item>
        <t-form-item label="光点颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.line.effect.color"/>
        </t-form-item>
        <t-form-item label="光点大小">
          <t-input-number size="small" v-model="attribute.line.effect.symbolSize" :min="0" :max="20" :decimal-places="0" :step="1"/>
        </t-form-item>
        <t-form-item label="光点尾迹">
          <t-input-number size="small" v-model="attribute.line.effect.trailLength" :min="0" :max="20" :decimal-places="1" :step="0.1"/>
        </t-form-item>
        <t-form-item label="移动速度(s)">
          <t-input-number size="small" v-model="attribute.line.effect.period" :min="1" :max="20" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="终点大小">
          <t-input-number size="small" v-model="attribute.line.endPoint.symbolSize" :min="0" :max="20" :decimal-places="0" :step="1"/>
        </t-form-item>
        <t-form-item label="终点颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.line.endPoint.itemStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="涟漪">
        <t-form-item label="label显示">
          <t-switch v-model="attribute.effectScatter.label.show" :label="['显示', '不显示']" size="small"/>
        </t-form-item>
        <t-form-item label="散开效果">
          <t-radio-group v-model="attribute.effectScatter.rippleEffect.brushType">
            <t-radio-button value="fill">面</t-radio-button>
            <t-radio-button value="stroke">线</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.effectScatter.itemStyle.color"/>
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number size="small" v-model="attribute.effectScatter.symbolSize" :min="1" :max="60" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="横纵比例">
          <t-input-number size="small" v-model="attribute.effectScatter.symbolScale" :min="0.5" :max="4" :decimal-places="1" :step="0.1"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="自定义覆盖物">
        <t-form-item label="覆盖物">
          <div @click="showGallery" style="width: 168px; height: 160px">
            <t-image style="width: 100%;height: 100%;background: none"
                     :src="attribute.customScatter.symbol? fileUrl + attribute.customScatter.symbol:require('@/assets/map/building.png')" fit="fill"/>
          </div>
        </t-form-item>
        <t-form-item label="大小" v-if="attribute.customScatter.symbolSize[0] !== undefined">
          <div>
            <div><t-input-number size="small" v-model="attribute.customScatter.symbolSize[0]" :min="0" :max="200" :decimal-places="0"/></div>
            <div><t-input-number size="small" v-model="attribute.customScatter.symbolSize[1]" :min="0" :max="200" :decimal-places="0"/></div>
          </div>
        </t-form-item>
        <t-form-item label="大小" v-else>
          <t-input-number size="small" v-model="attribute.customScatter.symbolSize" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="偏移X">
          <t-input-number size="small" v-model="attribute.customScatter.symbolOffsetX" :min="-100" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="偏移Y">
          <t-input-number size="small" v-model="attribute.customScatter.symbolOffsetY" :min="-100" :max="100" :decimal-places="0"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="地图" :expand="true">
        <t-form-item label="省份">
          <t-select v-model="attribute.provinceCode" size="small" @change="changeProvince">
            <t-option label="全国" value="china"/>
            <t-option v-for="(item,index) in cityProvince" :key="index" :label="item.name" :value="item.code"/>
          </t-select>
        </t-form-item>
        <t-form-item label="城市">
          <t-select v-model="attribute.cityCode" size="small" clearable>
            <t-option v-for="(item,index) in cities" :key="index" :label="item.name" :value="item.code"/>
          </t-select>
        </t-form-item>

        <t-form-item label="显示文本">
          <t-switch v-model="attribute.map.showLabel" :label="['显示', '不显示']" size="small"/>
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.map.color"/>
        </t-form-item>
        <t-form-item label="文本大小">
          <t-input-number size="small" v-model="attribute.map.fontSize" :min="4" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="边界线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.map.borderColor"/>
        </t-form-item>
        <t-form-item label="区域颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.map.areaColor"/>
        </t-form-item>
        <t-form-item label="横纵比例">
          <t-input-number size="small" v-model="attribute.map.aspectScale" :min="0.5" :max="2" :decimal-places="2" :step="0.01"/>
        </t-form-item>
        <t-form-item label="阴影">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.map.shadowColor"/>
        </t-form-item>
        <t-form-item label="阴影模糊">
          <t-input-number size="small" v-model="attribute.map.shadowBlur" :min="0" :max="20" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="阴影偏移X">
          <t-input-number size="small" v-model="attribute.map.shadowOffsetX" :min="0" :max="50" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="阴影偏移Y">
          <t-input-number size="small" v-model="attribute.map.shadowOffsetY" :min="0" :max="50" :decimal-places="0"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="条件配色" :expand="true" ref="pieceCollapse">
        <t-form-item label="默认颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.map.areaColor"/>
        </t-form-item>
        <div style="padding: 0 4px 0 4px;">
          <div v-for="(item,index) in attribute.visualMap.pieces" :key="index" class="conditionItem">
            <div>
              <div class="formLabel">标签</div>
              <div class="formItem">{{item.label}}</div>
            </div>
            <div>
              <div class="formLabel">数值区间</div>
              <div class="formItem">{{'['+(item.gte === undefined? '∞':item.gte)+','+(item.lt === undefined ? '∞':item.lt)+')'}}</div>
            </div>
            <div>
              <div class="formLabel">颜色</div>
              <div class="formItem" style="width: 20px;height: 20px;" :style="{backgroundColor:attribute.color[index]}"></div>
            </div>
            <div style="position: absolute;width: 50px;height: 35px;cursor: pointer;top: 0;right: 0">
              <t-icon name="edit" @click="editPiece(item,index)"/>
              <t-icon style="margin-left: 10px" name="delete" @click="delPiece(index)"/>
            </div>
          </div>
          <t-button block @click="addPiece()" :disabled="attribute.visualMap.pieces.length >= 7">新增条件</t-button>
        </div>
      </e-collapse>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
    <t-dialog header="新增条件配色" v-model:visible="modelShow" @confirm="onConfirm" :zIndex="2000" width="640">
      <div style="height: 100%;overflow: hidden">
        <t-form>
          <t-form-item label="标签">
            <t-input v-model="currPiece.label"/>
          </t-form-item>
          <t-form-item label="数值区间">
            <div style="width: 80px;text-align: center">大于等于</div>
            <t-input-number v-model="currPiece.gte"/>
            <div style="width: 80px;text-align: center">小于</div>
            <t-input-number v-model="currPiece.lt"/>
          </t-form-item>
          <t-form-item label="颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="currPiece.color"/>
          </t-form-item>
        </t-form>
      </div>
    </t-dialog>
  </div>
</template>

<script>
import {getChildByParentCode} from "@/utils/map-manage";
import cityProvince from "@/assets/map/city-province.json";
import {fileUrl} from "/env";
import Gallery from "@/components/designer/gallery";
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-map-migrate-option",
  props: {attribute: Object,cptDataForm:Object,},
  components: {EChartPosition, Gallery,CptData},
  data(){
    return {
      fileUrl,
      cityProvince,
      currentProvince:'',
      cities:[],
      modelShow:false,
      currPiece:{
        label:'',
        gte:0,
        lt:0,
        color:'#000'
      },
      currPieceIndex:null
    }
  },
  created() {
    this.loadChild(this.attribute.provinceCode)
  },
  methods:{
    loadChild(val){
      if(val === 'china'){
        this.cities = [];
      }else{
        this.cities = getChildByParentCode(val)
      }
    },
    changeProvince(val){
      this.attribute.cityCode = ''
      this.loadChild(val)
    },
    showGallery(){
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.customScatter.symbol = fileUrl
    },
    onConfirm(){
      if(this.currPiece.gte === null || this.currPiece.gte === ''){
        this.currPiece.gte = undefined
      }
      if(this.currPiece.lt === null || this.currPiece.lt === ''){
        this.currPiece.lt = undefined
      }
      if(this.currPieceIndex !== null){
        const temp = {
          label:this.currPiece.label,
          gte: this.currPiece.gte,
          lt: this.currPiece.lt
        }
        this.attribute.visualMap.pieces.splice(this.currPieceIndex,1,temp)
        if(this.attribute.color[this.currPieceIndex]){
          this.attribute.color[this.currPieceIndex] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
      }else{
        this.attribute.visualMap.pieces.push(JSON.parse(JSON.stringify(this.currPiece)))
        const index = this.attribute.visualMap.pieces.length - 1
        if(this.attribute.color[index]){
          this.attribute.color[index] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
        this.$nextTick(()=>{
          this.$refs.pieceCollapse.resize()
        })
      }
      this.modelShow = false
    },
    addPiece(){
      this.currPieceIndex = null
      this.modelShow = true
    },
    editPiece(item, index){
      this.currPieceIndex = index
      this.currPiece.label = item.label
      this.currPiece.gte = item.gte
      this.currPiece.lt = item.lt
      this.currPiece.color = this.attribute.color[index]
      this.modelShow = true
    },
    delPiece(index){
      this.attribute.visualMap.pieces.splice(index,1)
      this.attribute.color.splice(index,1)
    }
  }
}
</script>

<style scoped>
.conditionItem{width: 100%;background: rgba(0,0,0,0.2);padding-top: 6px;line-height: 35px;position: relative;margin-bottom: 4px;}
.formLabel{display: inline-block;width: 100px;text-align: center}
.formItem{display: inline-block;}
</style>
